import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FormDrawer } from "../../../../components/Form/FormDrawer";
import { CancelForm } from "./CancelForm";
import { ConfirmForm } from "./ConfirmForm";
import {
	CreateOrderStatusHistory,
	getOrderStatus,
} from "../../../../apis/cart/Order/OrderStatusHistory";
import { showToast } from "../../../../utils/toast";
import FormWrapper from "../../../../components/Form/FormWrapper";

export const OrderStatusForm = ({ order, handleClose, open }) => {
	const form = useForm({
		defaultValues: {
			old_status: "",
			new_status: "",
		},
	});
	const {
		handleSubmit,
		control,
		watch,
		reset,
		setValue,
		formState: { errors },
	} = form;
	const [dialogOpen, setDialogOpen] = useState(false);
	const [message, setMessage] = useState("");

	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState([]);

	const preparePayload = (data) => ({
		...data,
		products: data.products.map((product) => ({
			...product,
			start_date: product.start_date?.format("YYYY-MM-DD") ?? null,
			end_date: product.end_date?.format("YYYY-MM-DD") ?? null,
			return_in_days: product.return_in_days
				? Number(product.return_in_days)
				: null,
			allow_return: !!product.allow_return,
		})),
	});
	const watch_status = watch("new_status");
	const onSubmit = async (data) => {
		console.log("Form Data:", data);
		const payload = preparePayload(data);

		console.log("Final Payload:", payload);
		try {
			const res = await CreateOrderStatusHistory(order.id, payload);

			if (res.success) {
				if (res.exists) {
					setMessage(res.message);
					setDialogOpen(true);
				} else {
					showToast(
						`Order moved to ${watch_status} tab successfully!`,
						"success"
					);
					handleClose();
				}
			} else {
				showToast(
					res.message ||
					"Failed to update order status. Please try again.",
					"error"
				);
			}
		} catch (error) {
			console.error("Error while updating order status:", error);
			showToast("Something went wrong. Please try again.", "error");
		}
	};

	useEffect(() => {
		const loadStatus = async () => {
			if (open) {
				setLoading(true);
				setValue("old_status", order?.status);

				const res = await getOrderStatus(10, 1, {
					stage: "initial",
				});
				setStatus(res.results);
				setLoading(false);
			} else {
				reset();
			}
		};

		loadStatus();
	}, [open, order?.status, reset, setValue]);

	return (
		<FormDrawer open={open} setEditOpen={handleClose} loading={loading}>
			<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
				<Typography color={"primary"} variant="h4">
					Order Status
				</Typography>
				<Box my={3}>
					<FormControl fullWidth error={Boolean(errors.new_status)}>
						<InputLabel id="order-status-label">Status</InputLabel>
						<Controller
							// defaultValue={""}
							name="new_status"
							rules={{ required: "Select Status" }}
							control={control}
							render={({ field }) => (
								<Select
									labelId="order-status-label"
									id="order-status"
									// value={age}
									{...field}
									value={field.value ?? ""}
									label="Status"
								// onChange={handleChange}
								>
									{status?.map((stat, i) => (
										<MenuItem
											value={stat.name}
											key={`status-${i}`}
										>
											{stat.name}
										</MenuItem>
									))}
								</Select>
							)}
						/>
						{errors.new_status && (
							<FormHelperText>
								{errors.new_status?.message}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
				<Box my={3}>
					{watch_status === "Cancelled" && (
						<CancelForm form={form} order={order} />
					)}
					{watch_status === "Confirmed" && (
						<ConfirmForm form={form} order={order} />
					)}
				</Box>
				<Box my={3}>
					<Button type="submit" fullWidth variant="contained">
						Update Status
					</Button>
				</Box>
			</FormWrapper>

			<Dialog
				open={dialogOpen}
				onClose={(event, reason) => {
					if (
						reason !== "backdropClick" &&
						reason !== "escapeKeyDown"
					) {
						setDialogOpen(false);
					}
				}}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => window.location.reload()} autoFocus>
						Yes, Refresh
					</Button>
				</DialogActions>
			</Dialog>
		</FormDrawer>
	);
};
